module.exports = __webpack_public_path__ + "static/img/26@2x.fae23925.png";